import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "fgm_ref";
const DROP_KEY = "fgm_drop_code";

/**
 * Read ?ref=XYZ from the current URL. If present:
 *  - persist to localStorage
 *  - ping backend to increment click count
 * Returns the active referral code (from URL or localStorage), or null.
 */
export async function captureReferralFromUrl() {
    try {
        const params = new URLSearchParams(window.location.search);
        const fromUrl = params.get("ref");
        if (fromUrl) {
            localStorage.setItem(KEY, fromUrl);
            axios.post(`${API}/referrals/track`, { code: fromUrl }).catch(() => {});
        }
        // Also capture drop discount code (?drop=SUMMERHEAT)
        const dropFromUrl = params.get("drop");
        if (dropFromUrl) {
            localStorage.setItem(DROP_KEY, dropFromUrl.toUpperCase().trim());
        }
        if (fromUrl) return fromUrl;
    } catch (err) {
        console.warn("[FGM] captureReferralFromUrl failed:", err);
    }
    return getActiveReferral();
}

export function getActiveReferral() {
    try {
        return localStorage.getItem(KEY) || null;
    } catch {
        return null;
    }
}

export function getActiveDropCode() {
    try {
        return localStorage.getItem(DROP_KEY) || null;
    } catch {
        return null;
    }
}

export function clearReferral() {
    try {
        localStorage.removeItem(KEY);
    } catch (err) {
        console.warn("[FGM] clearReferral failed:", err);
    }
}

export function clearDropCode() {
    try {
        localStorage.removeItem(DROP_KEY);
    } catch (err) {
        console.warn("[FGM] clearDropCode failed:", err);
    }
}

export function shareUrlFor(code) {
    if (!code) return "";
    return `${window.location.origin}/?ref=${encodeURIComponent(code)}`;
}

